import { render, staticRenderFns } from "./TheProductTypesCreate.vue?vue&type=template&id=4e44c523"
import script from "./TheProductTypesCreate.vue?vue&type=script&lang=js"
export * from "./TheProductTypesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports